import { defineComponent, ref, computed, toRef } from 'vue-demi';
import './TimeFormat-a7f5565b.js';
import './dom-53c9635b.js';
import '@vueuse/core';
import { u as useProxyModelValue } from './useProxyModelValue-e18f251e.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import { s as script$1 } from './OrButton-e997c224.js';
import { s as script$2 } from './OrIcon-9aff520e.js';
import { s as script$4 } from './OrMenuItem-6caf8844.js';
import { s as script$3 } from './OrMenu-95509740.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createVNode, withCtx, createElementVNode, toDisplayString, createBlock, createCommentVNode, Fragment, renderList, createTextVNode } from 'vue';

const SortingRoot = [];
const SortingLabel = [
// Theme
'text-on-background dark:text-on-background-dark'];

var script = defineComponent({
  name: 'OrSorting',
  components: {
    OrButton: script$1,
    OrIcon: script$2,
    OrMenu: script$3,
    OrMenuItem: script$4
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: String,
      default: undefined
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  setup(props, context) {
    // Refs
    const root = ref();
    const sortMenu = ref();
    const sortButton = ref();
    // Styles
    const rootStyles = computed(() => ['or-sorting-v3', ...SortingRoot]);
    const sortLabelStyles = computed(() => [...SortingLabel]);
    // State
    const proxyModelValue = useProxyModelValue(toRef(props, 'modelValue'), context.emit);
    const sortLabel = computed(() => {
      var _a;
      return (_a = props.options.find(item => item.value === proxyModelValue.value)) === null || _a === void 0 ? void 0 : _a.label;
    });
    // Methods
    function handleSort(sort) {
      proxyModelValue.value = sort;
    }
    return {
      root,
      rootStyles,
      sortLabelStyles,
      sortMenu,
      sortButton,
      sortLabel,
      handleSort
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrButton = resolveComponent("OrButton");
  const _component_OrMenuItem = resolveComponent("OrMenuItem");
  const _component_OrMenu = resolveComponent("OrMenu");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createVNode(_component_OrButton, {
    ref: 'sortButton',
    variant: 'link',
    color: 'primary',
    onClick: _cache[0] || (_cache[0] = $event => _ctx.sortMenu && _ctx.sortMenu.toggle())
  }, {
    default: withCtx(() => [createElementVNode("span", {
      class: normalizeClass(_ctx.sortLabelStyles)
    }, toDisplayString(_ctx.sortLabel), 3 /* TEXT, CLASS */), _ctx.sortMenu ? (openBlock(), createBlock(_component_OrIcon, {
      key: 0,
      icon: _ctx.sortMenu.state === 'open' ? 'arrow_drop_up' : 'arrow_drop_down'
    }, null, 8 /* PROPS */, ["icon"])) : createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }), createVNode(_component_OrMenu, {
    ref: 'sortMenu',
    trigger: _ctx.sortButton && _ctx.sortButton.root,
    placement: 'bottom-start',
    offset: {
      mainAxis: 8,
      crossAxis: -8
    }
  }, {
    default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, item => {
      return openBlock(), createBlock(_component_OrMenuItem, {
        key: item.value,
        selected: item.value === _ctx.modelValue,
        onClick: $event => _ctx.handleSort(item.value)
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "onClick"]);
    }), 128 /* KEYED_FRAGMENT */))]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"])], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-sorting-v3/OrSorting.vue";

export { script as s };
